<template>
<div :for="name" class="option">
<ValidationProvider tag="div" :rules="rules" :label="label"  v-slot="{ errors }">

<!-- dummy radio start -->

<!-- design -->
   <!-- <div role="group" class="custom-control custom-radio">
   <input id="_safe_id_jd55j41rkhs" type="radio" name="Option 12" 
   class="custom-control-input" value="Option 1">
   <label for="_safe_id_jd55j41rkhs" class="custom-control-label"> Option 1 </label>
   </div> -->
<!-- dummy radio end -->
   

    <!-- {{rules}} -->
<!-- radio with functionality start -->

            <!-- <label class="form-check-label radio-center" for="inlineCheckbox1">
                <input type="radio"  v-model="selValueModel.code" class="form-check-input" :value="value" :name="name" v-on:input="emitValue">
                {{ label }}
            </label> -->

<!-- radio with functionality end -->


<div role="group" class="custom-control custom-radio">
    
     <input :id="name" type="radio" class="custom-control-input" 
     :disabled='disabled'
     v-model="selValueModel.code" 
     :value="value" :name="name" v-on:input="emitValue" />  
             <label :for="name" class="custom-control-label" >   {{ label }}
            </label>
    <label :for="name" class="click"></label>

</div>
        <div  v-if="errors && errors[0]" class="invalid-feedback icon">
            
          <div v-if="val=='1'">
            
            <span class="center">{{ errors[0] }}</span>
          </div>
        </div>
</ValidationProvider>
       </div>
    
</template>
<script>
import {  ValidationProvider} from "vee-validate";
export default {
   name: "cRadioButton",
   model: {
        prop: "selValue"
    },
   watch: {
        selValue(val) {
            if (val !== this.selValueModel) {
                this.selValueModel = val;
            }
        }
    },
    methods:{
    emitValue(){
         this.$emit("input", this.selValueModel)

    }
    },
   computed: {

        // selectedValue: {
        //     get: function() {
        //         return this.value
        //     },
        //     set: function() {
        //         // Communicate the change to parent component so that selectedValue can be updated
        //         this.$emit("input", this.selectedValue)
        //     }
        // }
    },
    components: {
        ValidationProvider,
    },
   
    props: {
        
        disabled:{
            type:Boolean,
            default:false
        },
        val: {
            type: String | Number,
            default: null
        },
        label: {
            type: String,
            default: ""
        },
        value: {
            type: String|Number,
            default: ""
        },
        name: {
            type: String|Number,
            default: ""
        },
        rules: {
            type: [String, Object],
            default: ""
        },
       selValue: {
      type: Object | Array,
      default: null
    },
          },

         data: () => ({
        selValueModel: null,
    }),
     created() {
    //    alert(JSON.stringify(this.selValue))
         this.selValueModel=this.selValue;
           
     }
    
   
}
</script>
<style scoped>
.invalid-feedback {
    display: block;
}
.radio-center{
    padding-left: 50px;
}

</style>
